module.exports = __webpack_public_path__ + "img/ico_phone.d2312e0e.svg";